import React, { useState } from 'react';
import catalog from '../../Images/catalog.png';
import arrow from '../../Images/arrow.png'; 
import '../../Styles/Catalog.css';
import { useNavigate } from "react-router-dom";
import WishlistButton from "./WishlistBtn";
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

export default function Catalog(props) {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const redirect = (id) => {
    navigate(`/Course/${id}`);
  };

  const shouldTruncate = props.coursetitle.length > 30;
  const truncatedTitle = shouldTruncate
    ? props.coursetitle.slice(0, 30) + "..."
    : props.coursetitle;

  const renderTooltip = (propsTooltip) => (
    <Tooltip id="custom-tooltip" {...propsTooltip} className="custom-tooltip">
      {props.coursetitle}
    </Tooltip>
  );

  return (
    <div className="catalog-card">
      <div className="catalog-image">
        <div className="image-padding">
          <img src={props.cover_img || catalog} alt={props.coursetitle} />
        </div>
      </div>

      <div className="catalog-content">
        <OverlayTrigger
          placement="top"
          overlay={renderTooltip}
          delay={{ show: 100, hide: 200 }}
        >
          <h3 className="catalog-title">
            {truncatedTitle}
            {shouldTruncate && (
              <span
                onClick={() => setShowModal(true)}
                className="view-more"
              >
                View more
              </span>
            )}
          </h3>
        </OverlayTrigger>

        <p>{props.instructor}</p>

        <div className="button-free">
          <div
            className="catalog-footer-main"
            onClick={() => redirect(props.courseId)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              className="catalog-footer"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="footermaincat">
                <div className="footerContenid">
                  <span className="catalog-price">{`RS ${props.price}`}</span>
                </div>
              </div>
            </div>
            <div className="enroll-now" style={{ marginLeft: "5px" }}>
              View Course
            </div>
            <div className="arrow">
              <img src={arrow} alt="Arrow icon" />
            </div>
          </div>

          <div className="wishlist-container">
            <div className="wishlist-btn">
              <WishlistButton
                courseId={props.courseId}
                isWishlisted={props.isWishlisted}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal for full title */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Full Title</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.coursetitle}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
